<template>
  <div>
    <el-table
      :data="users.data"
      :default-sort="{ prop: order_column, order: order_type }"
      @sort-change="sort"
      class="w100"
      stripe
      v-loading="loading"
    >
      <el-table-column label="Channels" width="100%">
        <template slot-scope="props">
          <div v-for="(value, key) in props.row.channels" :key="new Date().getTime() + key">
            <el-tooltip v-if="value" :content="value.channelName" placement="right">
              <div class="pointer social-icon" :style="channelBgImg(key, value)"
                   @click="openPlatform(key, value)"></div>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="First name" prop="first_name" sortable="custom">
        <template slot-scope="props">
          {{ props.row.first_name }}
          <span class="login-as-wrapper">
            <LoginAs :user="props.row" />
            <LoginAsNew :user="props.row" />
          </span>
        </template>
      </el-table-column>
      <el-table-column label="Last name" prop="surname" sortable="custom"></el-table-column>
      <el-table-column label="E-mail" prop="email" sortable="custom"></el-table-column>
      <el-table-column label="Country" prop="country_of_residence" sortable="custom"></el-table-column>
      <el-table-column label="User type" prop="user_level" sortable="custom">
        <template slot-scope="props">
          <el-tag class="capitalize" :type="tagType(props.row.user_level)">
            {{ typeName(props.row.user_level) | underscore_to_space }}
            <br/>
            <el-button v-if="props.row.is_mcn_manager"
                       type="primary"
                       class="btn-main"
                       style="margin: 5px 0; padding: 5px;font-size: 12px"
                       @click="openChannels(props.row)">view channels</el-button>
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="User level" prop="user_tier" sortable="custom">
        <template slot-scope="props">
          <el-tag :type="tierType(props.row.user_tier)">
            {{ tierName(props.row.user_tier) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="User tier" width="100" prop="creator_tier" sortable="custom">
        <template slot-scope="props">
          {{ props.row.creator_tier ? props.row.creator_tier : '/' }}
        </template>
      </el-table-column>
      <el-table-column label="Channel category" prop="ytCategory" sortable="custom" align="center">
        <template slot-scope="props">
          {{ props.row.yt_category ? props.row.yt_category.name : '/' }}
        </template>
      </el-table-column>
      <el-table-column label="Subscribers" prop="subscribers" sortable="custom">
        <template slot-scope="props">
          {{ props.row.subscribers ? commaNum(props.row.subscribers) : 0 }}
        </template>
      </el-table-column>
      <el-table-column label="User Wallet" prop="wallet" sortable="custom">
        <template slot-scope="props">
          {{ props.row.wallet ? '$'+props.row.wallet.toFixed(2) : '/' }}
        </template>
      </el-table-column>
      <el-table-column label="Monetization" prop="youtube_monetize" sortable="custom">
        <template slot-scope="props">
          {{
            props.row.youtube_monetize_updated
              ? (props.row.youtube_monetize ? "Yes" : "No") + " (" + moment(props.row.youtube_monetize_updated).format('DD MMMM YYYY')+")"
              : "/"
          }}
        </template>
      </el-table-column>
      <el-table-column label="Campaign source" prop="campaign_name" sortable="custom">
        <template slot-scope="props">
          {{ props.row.campaign_name }}
        </template>
      </el-table-column>
      <el-table-column label="Signup date" prop="created_at" sortable="custom">
        <template slot-scope="props">
          {{ moment(props.row.created_at).format('DD MMMM YYYY') }}
        </template>
      </el-table-column>
      <el-table-column label="Actions" width="170" align="center" v-if="level3">
        <template slot-scope="props">
          <el-tooltip content="Edit" placement="top">
            <el-button type="warning" circle size="small" icon="el-icon-edit"
                       @click="openEdit(props.row)"></el-button>
          </el-tooltip>
          <el-tooltip content="Delete" placement="top">
            <el-button type="danger" circle size="small" icon="el-icon-close"
              @click="deleteU(props.row.id)"></el-button>
          </el-tooltip>
          <el-tooltip content="Social Networks" placement="top" :disabled="disableSNTooltip">
            <SocialNetworks :channels="props.row.channels" @tierModal="(v) => disableSNTooltip = v" />
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="float-right" background @size-change="sizeChange" @current-change="currentChange"
      :current-page.sync="users.current_page" :page-sizes="[10, 25, 50, 100]" :page-size="page_size"
       layout="total, sizes, prev, pager, next, jumper" :total="users.total"
    ></el-pagination>
    <el-dialog
        :visible.sync="dialogVisible"
        width="80%"
        :before-close="handleClose"
        :title="dialogTitle">
      <mcn-channels :user="selectedUser"></mcn-channels>
    </el-dialog>
  </div>
</template>

<script>
import SocialNetworks from "@/modules/admin/user/components/SocialNetworks";
import LoginAs from '@/modules/admin/user/components/LoginAs.vue'
import { mapState, mapActions, mapMutations } from 'vuex'
import { pick as _pick } from 'lodash'
import moment from 'moment'
import store from "../../../../plugins/vuex";
import McnChannels  from "@/modules/admin/cms/views/McnChannels";
import LoginAsNew from '@/modules/admin/user/components/LoginAsNew.vue'

export default {
  data() {
    return {
      dialogTier: false,
      user_tier: '',
      user_channel: [],
      user_status: null,
      moment: moment,
      disableSNTooltip: false,
      dialogVisible: false,
      selectedUser: null,
    }
  },

  components: {
    LoginAs,
    LoginAsNew,
    SocialNetworks,
    McnChannels
  },

  computed: {
    ...mapState('user', [
      'user',
      'users',
      'page',
      'page_size',
      'order_column',
      'order_type',
      'loading'
    ]),
    level3: function() {
      if (store.state.auth.user.permission === 3) return true
      else {
        return false
      }
    },
    dialogTitle() {
      return this.selectedUser && this.selectedUser.name
          ? `Channels for ${this.selectedUser.name}`
          : 'Channels';
    }
  },

  methods: {
    ...mapActions('user', [
      'read',
      'delete',
      'update',
      'getCompanyAdminArtist'
    ]),
    ...mapActions('artistUsers', ['readArtistUsers']),
    ...mapActions('creatorUsers', ['readCreatorUsers']),
    ...mapActions('labelUsers', ['readLabelUsers']),
    ...mapActions('mcnUsers', ['readMcnUsers']),
    ...mapActions('permissionUsers', ['readPermissionUsers']),
    ...mapActions('cidUsers', ['fetchUsers']),
    ...mapActions('newUsers', ['readNewUsers']),
    ...mapMutations('user', [
      'setPage',
      'setPageSize',
      'setOrdering',
      'setDialog',
      'setSelectedUser',
      'setShowWallet',
      'setTierDialog'
    ]),
    sizeChange(page_size) {
      this.setPageSize(page_size)
      this.read()
    },
    currentChange(page) {
      this.setPage(page)
      this.read()
    },
    sort(d) {
      this.setOrdering({
        column: d.prop,
        type: this.ascDesc(d.order)
      })
      this.read()
    },
    tagType(level) {
      switch (level) {
        case 'guest':
          return 'info'
        case 'user':
          return 'success'
        case 'company_admin':
          return ''
        case 'sysadmin':
          return 'danger'
        default:
          return 'warning'
      }
    },
    channelBgImg(platform, data) {
      let img = require(`@/assets/icons/${platform}.svg`)
      return `
        mask-image:url('${img}');
        -webkit-mask:url('${img}');
        background-repeat: no-repeat;
        background-position-x: right;
        background-origin: content-box;
        background-size: 25px;
        background-color: ${this.socialIconColor(data)};
      `
    },

    socialIconColor(data) {
      let color = 'black'
      if (data.approved === 1) color = '#67C23A'
      else if (data.approved === 2) color = '#d40c41'
      else if (data.approved === 3) color = '#ffa500'
      return color
    },

    openPlatform(platform, data) {
      if (platform === 'youtube') {
        window.open('https://youtube.com/channel/' + data.channelId)
      }
      else if (platform === 'instagram') {
        if (data.channelId.startsWith('https://')){
          window.open(data.channelId);
        } else {
          window.open('https://instagram.com/' + data.channelId);
        }
      }
      else if (platform === 'tiktok') {
        if (data.channelId.startsWith('https://')){
          window.open(data.channelId);
        } else {
          window.open('https://tiktok.com/' + data.channelId);
        }
      }
    },

    openEdit(user) {
      user = _pick(user, [
        'surname', 'user_level', 'user_tier', 'wallet', 'label', 'id', 'first_name', 'email',
        'country_of_residence', 'artist', 'company_admin', 'image_url', 'featured', 'leaderboard',
        'spotlight', 'name', 'phone', 'birthday', 'address', 'biography', 'quote', 'permission', 'channels', 'channel_report', 'is_mcn_manager',
        'channel_management_reporting_enabled', 'shorts_revenue_reports_enabled',
      ])
      this.setShowWallet(true)
      this.setSelectedUser(JSON.parse(JSON.stringify(user)))
      this.setDialog(true)
    },

    openChannels(user) {
      this.selectedUser = { ...user }; // Pass the selected user data
      this.dialogVisible = true;
    },
    handleClose() {
      this.dialogVisible = false;
      this.selectedUser = null;
    },
    deleteU(id) {
      this.$confirm(
        'You will permanently delete this user. Continue?',
        'Warning',
        {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }
      )
        .then(() => {
          this.delete(id)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: 'Delete cancelled'
          })
        })
    }
  },

  created() {
    this.read()
    this.getCompanyAdminArtist()
  }
}
</script>

<style scoped>
.social-icon {
  width: 25px;
  height: 25px;
  margin-bottom: 3px;
}
.login-as-wrapper {
  display: inline-flex;
  gap: 6px;
  margin-left: 8px;
  vertical-align: middle;
}
</style>
